import React from "react";
import parse from "html-react-parser";
import "../../css/jobs.css";

function AboutJob(props: any) {
  const { companyData, companyJobData } = props;

  return (
    <div className="summary-area__summary_content">
      <div className="summary__about-job">
        <h5>About the Job</h5>
        {companyJobData?.companyJob?.jobDescription && (
          <p>
            {parse(
              // "<p><strong>Responsibilities:&nbsp;</strong></p><ul><li>Provide support to L1 in alert triage.</li><li>Perform health checks of SIEM and clients.&nbsp;</li><li>Conduct eyes-on-the-glass threat hunting.&nbsp;</li><li>Handle escalations in an efficient manner.</li><li>Perform hunts based off ad-hoc requests for clients and management.&nbsp;</li><li>Monitor cyber space for threats and hunt for IOCs and IOAs.&nbsp;</li><li>Ensure that documentation is up to date.</li><li>Conduct regular meetings with the client(s).</li><li>Provide support to IR team.<br>&nbsp;</li></ul><p><strong>Requirements:</strong></p><ul><li>Minimum Bachelor’s degree in Information Security.</li><li>Minimum 01 year of experience working in SOC.</li><li>CEH / CHFI / CYSA+ and/ or other relevant certifications.</li><li>Good analytical Skills.</li><li>Excellent communication and interpersonal skills.&nbsp;</li><li>Experience with SIEM / SOC technology.</li><li>Experience with AV / EDR deployment and response (Microsoft Defender and Crowdstrike).</li><li>Good understanding and practical experience of Incident categorization, investigation and response life cycle.</li><li>Ability to work in rotating shifts.</li></ul>"
              companyJobData?.companyJob?.jobDescription
            )}
          </p>
        )}
      </div>
      <div className="summary__about-company">
        <h5>{`About the ${
          typeof companyData?.companyName != "undefined"
            ? companyData?.companyName
            : ""
        }`}</h5>
        <p>{`${
          typeof companyData?.about != "undefined"
            ? companyData?.about
            : "Digital Transformation | Information Security | DevOps | Resource as a Service"
        }`}</p>
      </div>
    </div>
  );
}

export default AboutJob;
